import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  try {
    let sid = localStorage.getItem('geet_sid');
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
      localStorage.setItem('geet_sid', sid);
    }
    return sid;
  } catch {
    return '';
  }
}

function getDevice() {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return 'tablet';
  if (/Mobi|iPhone|Android|iPod/i.test(ua)) return 'mobile';
  return 'desktop';
}

function getBrowser() {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (/Edg/i.test(ua)) return 'Edge';
  if (/OPR|Opera/i.test(ua)) return 'Opera';
  if (/Chrome/i.test(ua)) return 'Chrome';
  if (/Firefox/i.test(ua)) return 'Firefox';
  if (/Safari/i.test(ua)) return 'Safari';
  return 'Other';
}

function getUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get('utm_source') || '',
      utm_medium: p.get('utm_medium') || '',
      utm_campaign: p.get('utm_campaign') || '',
    };
  } catch {
    return { utm_source: '', utm_medium: '', utm_campaign: '' };
  }
}

export function venueFromPath(pathname) {
  if (pathname.startsWith('/geet')) return 'geet';
  if (pathname.startsWith('/ogeet')) return 'ogeet';
  if (pathname === '/') return 'landing';
  return 'unknown';
}

export function track(type, venue, path = '') {
  // fire-and-forget; never block the UI
  try {
    const utm = getUTM();
    axios.post(`${API}/analytics/track`, {
      type,
      venue,
      path: path || (typeof window !== 'undefined' ? window.location.pathname : ''),
      session_id: getSessionId(),
      referrer: typeof document !== 'undefined' ? document.referrer : '',
      device: getDevice(),
      browser: getBrowser(),
      title: typeof document !== 'undefined' ? document.title : '',
      ...utm,
    }).catch(() => {});
  } catch {
    /* no-op */
  }
}

export function trackPageView(pathname) {
  track('page_view', venueFromPath(pathname), pathname);
}

export function trackWhatsapp(venue) {
  track('whatsapp_click', venue);
}

export function trackAction(type, venue) {
  track(type, venue);
}
